import { AuthRepository } from "../AuthRepository";

const authRepo = new AuthRepository();

export class SamlOAuthService {
  public static AUTH_CHANNEL = "saml_auth_channel";

  public static MESSAGES = {
    USER_AUTHENTICATED: "UserAuthenticated",
  };

  static extractDomain(email: string): string | null {
    return email.split("@")[1]?.toLowerCase() ?? null;
  }

  static async getOrganizationSlug(email: string): Promise<string> {
    const domain = SamlOAuthService.extractDomain(email);
    if (!domain) {
      throw new Error("Invalid email address");
    }
    const { organization_slug } = await authRepo.checkSamlDomain(domain);
    return organization_slug;
  }

  static async getAuthUrl(organizationSlug: string): Promise<string> {
    return authRepo.getSamlAuthUrl(organizationSlug);
  }
}
